import { request } from "@/store";
import Filter from "@/store/filter";
var _ = require("lodash");
const alerts = {
  state: {
    list: [],
    assignees: [],
    urgencyCount: 0
  },
  mutations: {
    urgencyCountSet(state, payload) {
      state.urgencyCount = payload;
    },
    alertsListSet(state, payload) {
      state.list = payload.map((item, index) => {
        const assignee = state.assignees[index % state.assignees.length] || {};
        return {
          ...item,
          id: index + 1,
          status: "in_progress",
          created_at: new Date(),
          assignee: {
            id: assignee.id,
            name: assignee.name,
            color: assignee.color,
            back: assignee.back
          }
        };
      });
    },
    filteredalertsListSet(state, payload) {
      state.list = state.list.map(existingItem => {
        const updated = payload.find(p => p.sku === existingItem.sku);
        if (!updated) return existingItem;
        return {
          ...existingItem,
          status: updated.status ?? existingItem.status,
          created_at: updated.created_at ?? existingItem.created_at,
          assignee: {
            ...existingItem.assignee,
            name: updated.assignee ?? existingItem.assignee.name
          }
        };
      });
    },
    assigneesListSet(state, payload) {
      const colorPalette = [{
        color: "#22863D",
        back: "#DEFBE6"
      }, {
        color: "#DB2473",
        back: "#FFD6E8"
      }, {
        color: "#D7AA0F",
        back: "#FDF6DE"
      }];
      state.assignees = payload.map(user => {
        const randomIndex = Math.floor(Math.random() * colorPalette.length);
        const {
          color,
          back
        } = colorPalette[randomIndex];
        return {
          id: user.id,
          name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          color,
          back
        };
      });
    }
  },
  actions: {
    async alertsUrgentCount({
      commit
    }, payload) {
      let data = (await request("/alerts/get_urgent_alerts_count", "POST", payload)) ?? {
        data: []
      };
      if (data) {
        console.log("alert count", data);
        commit("urgencyCountSet", data.count);
      }
      return data;
    },
    async alertsList({
      commit
    }, payload) {
      let data = (await request("/alerts/get_alerts_by_seller_id_from_gcp", "POST", payload)) ?? {
        data: []
      };
      if (data) {
        commit("alertsListSet", Array.isArray(data.data) ? data.data : []);
        commit("urgencyCountSet", data.total_rows ?? 0);
      }
      return data;
    },
    async alertsListFromPostGres({
      commit
    }, payload) {
      let result = (await request("/alerts/get_alerts_by_seller_id", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("filteredalertsListSet", result.data);
      }
      return result;
    },
    async assigneesList({
      commit
    }, payload) {
      let data = (await request("/workspace/members", "POST", payload)) ?? {
        data: []
      };
      if (data) {
        commit("assigneesListSet", data.members);
      }
      return data;
    },
    async updatingAlertingStatus({
      state
    }, payload) {
      //console.log("[update alert before server]");
      //console.log(payload);
      let result = await request("/alerts/update_status_of_alerts", "POST", payload);
      return result;
    }
  }
};
export default alerts;